import { css, Theme } from '@emotion/react';

const styles = {
  section: ({ palette }: Theme) =>
    css({
      backgroundColor: palette.GREY_3,
    }),
};

export default styles;
